module.exports = __webpack_public_path__ + "img/einstein_tower.2726df89.jpg";